<template>
	<div style="height: 100%;">
    <k-panel fill-height>
      <template #title>
        <k-icon small>inventory</k-icon>
        <span class="ml-2">Productions</span>
      </template>
      <template #default>
        <production-channel 
          v-for="channel in channels"
          :channel="channel"
          :channel_id="channel.uuid" 
          :key="channel.uuid"
        ></production-channel>
      </template>
    </k-panel>
  </div>
</template>

<script>

import ChannelModel from '@/models/channel.js'
import ProductionChannel from './Channel.vue'

export default {
  components: {
    ProductionChannel
  },
  data () {
    return {
    }
  },
  methods: {
    title(channel) {
      return ChannelModel.title(channel);
    },
    instance(channel) {
      return ChannelModel.instance(channel);
    },
    is_transcoder(channel) {
      return ChannelModel.is_transcoder(channel);
    },
    is_cloudstreamer(channel) {
      return ChannelModel.is_cloudstreamer(channel);
    },
    can_start(channel) {
      // FIXME: käyttöoikeustarkistuksia
      return true;
    }
  },
  computed: {
    search_text () {
      return this.$store.state.search_text;
    },
    channels () {
      var self = this;
      var search = (this.search_text || "").toLowerCase();
      var channels = ChannelModel.list_active_channels();

      var ret = _.filter(channels, function(channel) {  
        if (ChannelModel.is_cloudstreamer(channel)) return true;
        if (ChannelModel.get_type(channel) == "output" && ChannelModel.is_transcoder(channel) == false) return true;
        return false;
      });

      if (this.search_text != "" && this.search_text) {
        var ret = _.filter(ret, (channel) => {
          if (ChannelModel.title(channel).toLowerCase().includes(search)) return true;
        });
      }

      return _.sortBy(ret, function(o) { return [ChannelModel.title(o)] });
    }
  }
}
</script>